export const recipients = [
    "Recipient 1",
    "Recipient 2",
    "Recipient 3",
    "Recipient 4",
    "Recipient 5",
];

export const cc = [
    "Cc 1",
    "Cc 2",
    "Cc 3",
    "Cc 4",
    "Cc 5",
];

export const addRecipients = [
    "test 1",
    "test 2",
    "test 3",
    "test 4",
    "test 5",
];

export const bcc = [
    "Bcc 1",
    "Bcc 2",
    "Bcc 3",
    "Bcc 4",
    "Bcc 5",
];